import { z } from "zod";

export const leaveRegisterRowSchema = z
  .object({
    membershipId: z.string(),
    memberName: z.string(),
    departmentName: z.string().nullable(),
    leaveTypeId: z.string(),
    leaveTypeName: z.string(),
    openingBalance: z.string(),
    allocated: z.string(),
    carriedForward: z.string(),
    consumed: z.string(),
    encashed: z.string(),
    expired: z.string(),
    adjusted: z.string(),
    closingBalance: z.string(),
    pendingDays: z.string(),
  })
  .strict();

export const leaveRegisterSchema = z
  .object({ rows: z.array(leaveRegisterRowSchema), nextCursor: z.string().nullable() })
  .strict();

export type LeaveRegister = z.infer<typeof leaveRegisterSchema>;
